// Iconos line-art con esquinas redondeadas (estilo infantil-profesional).
// Tamaño por defecto 1em; controla color con currentColor / className text-*.

const base = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

function svg(children, { size = '1em', className = '' } = {}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      aria-hidden="true"
      className={className}
      {...base}
    >
      {children}
    </svg>
  );
}

export function BookIcon(props) {
  return svg(
    <>
      <path d="M4 5a2 2 0 0 1 2-2h12v15H6a2 2 0 0 0-2 2V5z" />
      <path d="M4 19a2 2 0 0 0 2 2h12" />
      <path d="M9 7h6M9 11h5" />
    </>,
    props
  );
}

export function SparkleIcon(props) {
  return svg(
    <>
      <path d="M12 4v4M12 16v4M4 12h4M16 12h4" />
      <path d="M7 7l2.5 2.5M14.5 14.5L17 17M7 17l2.5-2.5M14.5 9.5L17 7" />
    </>,
    props
  );
}

export function RefreshIcon(props) {
  return svg(
    <>
      <path d="M3 12a9 9 0 0 1 15.5-6.3L21 8" />
      <path d="M21 3v5h-5" />
      <path d="M21 12a9 9 0 0 1-15.5 6.3L3 16" />
      <path d="M3 21v-5h5" />
    </>,
    props
  );
}

export function DownloadIcon(props) {
  return svg(
    <>
      <path d="M12 4v12" />
      <path d="M7 11l5 5 5-5" />
      <path d="M5 20h14" />
    </>,
    props
  );
}

export function ShareIcon(props) {
  return svg(
    <>
      <circle cx="18" cy="5" r="2.5" />
      <circle cx="6" cy="12" r="2.5" />
      <circle cx="18" cy="19" r="2.5" />
      <path d="M8.2 11l7.6-4.5M8.2 13l7.6 4.5" />
    </>,
    props
  );
}

export function EyeIcon(props) {
  return svg(
    <>
      <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" />
      <circle cx="12" cy="12" r="3" />
    </>,
    props
  );
}

export function ChevronLeftIcon(props) {
  return svg(<path d="M15 6l-6 6 6 6" />, props);
}
export function ChevronRightIcon(props) {
  return svg(<path d="M9 6l6 6-6 6" />, props);
}

// Logo: pluma sobre libro abierto, suficientemente abstracto para sentirse infantil-pro
export function LogoIcon(props) {
  return svg(
    <>
      <path d="M3 6a2 2 0 0 1 2-2h6v14H5a2 2 0 0 0-2 2V6z" />
      <path d="M13 4h6a2 2 0 0 1 2 2v14a2 2 0 0 0-2-2h-6V4z" />
      <path d="M16 9l4-3M16 9l-2 4 4-2" />
    </>,
    props
  );
}

export function MicIcon(props) {
  return svg(
    <>
      <rect x="9" y="3" width="6" height="12" rx="3" />
      <path d="M5 11a7 7 0 0 0 14 0" />
      <path d="M12 18v3M9 21h6" />
    </>,
    props
  );
}

export function StopIcon(props) {
  return svg(
    <rect x="6" y="6" width="12" height="12" rx="2" />,
    props
  );
}

export function PlayIcon(props) {
  return svg(
    <path d="M7 4.5v15l13-7.5-13-7.5z" />,
    props
  );
}

export function PauseIcon(props) {
  return svg(
    <>
      <rect x="6" y="5" width="4" height="14" rx="1" />
      <rect x="14" y="5" width="4" height="14" rx="1" />
    </>,
    props
  );
}

export function SpeakerIcon(props) {
  return svg(
    <>
      <path d="M3 10v4h4l5 4V6L7 10H3z" />
      <path d="M15.5 8.5a5 5 0 0 1 0 7" />
      <path d="M18.5 5.5a9 9 0 0 1 0 13" />
    </>,
    props
  );
}

export function CloseIcon(props) {
  return svg(
    <>
      <path d="M6 6l12 12" />
      <path d="M18 6L6 18" />
    </>,
    props
  );
}
